import { Navigate, Outlet } from 'react-router-dom';
import { useDeliveryAuth } from '../auth';

export function ProtectedRoute() {
  const { isAuthenticated, isInitialized } = useDeliveryAuth();

  if (!isInitialized) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
